import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import FirebaseService from 'services/FirebaseService';
import CoachService from 'services/CoachService';

export const initialState = {
	loading: false,
	message: '',
	showMessage: false,
	redirect: '',
	token: localStorage.getItem(AUTH_TOKEN) || null,
    coachData: [],
    singleCoach:[],
    coachGroup: [],
    coachSession: [],
    coachPlayer:[],
    resData:[],
    allSportData:[],
    allClubData:[],
}


export const getCoach = createAsyncThunk('coach/getCoach', async (params, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.getCoach(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const getCoachWithId = createAsyncThunk('coach/getCoachWithId', async (params, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.getCoachWithId(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getCoachGroup = createAsyncThunk('coach/getCoachGroup', async (params, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.getCoachGroup(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});
export const getCoachSession = createAsyncThunk('coach/getCoachSession', async (params, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.getCoachSession(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});
export const getCoachPlayer = createAsyncThunk('coach/getCoachPlayer', async (params, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.getCoachPlayer(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const createCoach = createAsyncThunk('coach/createCoach', async (data, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.createCoach(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getAllSports = createAsyncThunk('coach/getAllSports', async (params, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.getAllSports(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const getAllClub = createAsyncThunk('coach/getAllClub', async (params, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.getAllClub(params)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const trialCoach = createAsyncThunk('coach/trialCoach', async (data, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.trialCoach(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const deleteCoach = createAsyncThunk('coach/deleteCoach', async (data, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.deleteCoach(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});

export const updateCoach = createAsyncThunk('coach/updateCoach', async (data, { rejectWithValue }) => {
	
	try {
		const response = await CoachService.updateCoach(data)
		if (response.status) {
			console.log(response);
            return response.data
		} else {
			return rejectWithValue(response.message?.replace('Firebase: ', ''));
		}
	} catch (err) {
		return rejectWithValue(err.message || 'Error')
	}
});


export const coachSlice = createSlice({
    name: 'coach',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
        .addCase(getCoach.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(getCoach.fulfilled, (state, action) => {
            state.loading = false
            state.coachData = action.payload
        })
        .addCase(getCoach.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
       
        .addCase(getCoachWithId.pending, (state) => {
            state.loading = true
        })
        .addCase(getCoachWithId.fulfilled, (state, action) => {
            state.loading = false
            state.singleCoach = action.payload
        })
        .addCase(getCoachWithId.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getCoachGroup.pending, (state) => {
            state.loading = true
        })
        .addCase(getCoachGroup.fulfilled, (state, action) => {
            state.loading = false
            state.coachGroup = action.payload
        })
        .addCase(getCoachGroup.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getCoachSession.pending, (state) => {
            state.loading = true
        })
        .addCase(getCoachSession.fulfilled, (state, action) => {
            state.loading = false
            state.coachSession = action.payload
        })
        .addCase(getCoachSession.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getCoachPlayer.pending, (state) => {
            state.loading = true
        })
        .addCase(getCoachPlayer.fulfilled, (state, action) => {
            state.loading = false
            state.coachPlayer = action.payload
        })
        .addCase(getCoachPlayer.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(createCoach.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(createCoach.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
            state.message = "coach Added"
        })
        .addCase(createCoach.rejected, (state, action) => {
           // state.message = action.payload
           // state.showMessage = true
            state.loading = false
        })
        .addCase(getAllSports.pending, (state) => {
            state.loading = true
        })
        .addCase(getAllSports.fulfilled, (state, action) => {
            state.loading = false
            state.allSportData = action.payload
        })
        .addCase(getAllSports.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(getAllClub.pending, (state) => {
            state.loading = true
        })
        .addCase(getAllClub.fulfilled, (state, action) => {
            state.loading = false
            state.allClubData = action.payload
        })
        .addCase(getAllClub.rejected, (state, action) => {
            state.message = action.payload
            state.showMessage = true
            state.loading = false
        })
        .addCase(trialCoach.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(trialCoach.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
            state.message = "Trial Updated"
        })
        .addCase(trialCoach.rejected, (state, action) => {
           // state.message = action.payload
           // state.showMessage = true
            state.loading = false
        })
        .addCase(deleteCoach.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(deleteCoach.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
            state.message = "Coach Deleted"
        })
        .addCase(deleteCoach.rejected, (state, action) => {
           // state.message = action.payload
           // state.showMessage = true
            state.loading = false
        })
        .addCase(updateCoach.pending, (state) => {
            state.loading = true
            state.message = ''
        })
        .addCase(updateCoach.fulfilled, (state, action) => {
            state.loading = false
            state.resData = action.payload
            state.message = "Coach Updated"
        })
        .addCase(updateCoach.rejected, (state, action) => {
           // state.message = action.payload
           // state.showMessage = true
            state.loading = false
        })
       
    }
});


export default coachSlice.reducer;